import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_coupon_image = _resolveComponent("coupon-image")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_coupon_data = _resolveComponent("coupon-data")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_coupon_options = _resolveComponent("coupon-options")!
  const _component_coupon_approbation_buttons = _resolveComponent("coupon-approbation-buttons")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_coupon_status = _resolveComponent("coupon-status")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_coupon_cropper = _resolveComponent("coupon-cropper")!

  return (_openBlock(), _createBlock(_component_v_col, {
    cols: "12",
    class: _normalizeClass({ 'coupon-card': true, 'processed': _ctx.isProcessed, 'is-relative': true })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { rounded: "0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    class: _normalizeClass(["coupon-image text-center text-lg-center", { 'form-disabled': !_ctx.vehicleSelected || _ctx.isProcessed }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar, {
                        density: "compact",
                        floating: "",
                        absolute: "",
                        elevation: "2",
                        class: "coupon-image-controls"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, { icon: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "error",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete', { id: _ctx.item.id, importState: _ctx.item.importState })))
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode(" mdi-trash-can-outline ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            icon: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cropping = true))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-crop", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_component_coupon_image, {
                        ref: "couponImage",
                        key: _ctx.version + '',
                        item: _ctx.item,
                        onTransfer: _ctx.transferElement
                      }, null, 8, ["item", "onTransfer"]))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: _normalizeClass({ 'form-disabled': !_ctx.vehicleSelected || _ctx.isProcessed })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_coupon_data, {
                                item: _ctx.item,
                                "batch-data": _ctx.batchData
                              }, null, 8, ["item", "batch-data"])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_coupon_options, {
                                item: _ctx.item,
                                class: _normalizeClass({ 'form-disabled': !_ctx.vehicleSelected || _ctx.isProcessed }),
                                isDisabled: !_ctx.vehicleSelected || _ctx.isProcessed,
                                "batch-data": _ctx.batchData,
                                onValid: _cache[2] || (_cache[2] = (v) => (_ctx.valid = v)),
                                onCouponFields: _cache[3] || (_cache[3] = (v) => (_ctx.couponFields = v))
                              }, null, 8, ["item", "class", "isDisabled", "batch-data"]),
                              _createVNode(_component_v_row, { align: "center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    lg: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_coupon_approbation_buttons, {
                                        loading: _ctx.loading,
                                        loadingError: _ctx.loadingError,
                                        withErrors: !_ctx.valid,
                                        data: { currentScanner: _ctx.currentScanner, batchId: _ctx.batchData?.batchId },
                                        "success-btn-label": _ctx.currentScanner.isAppMembre ? 'Approuver' : 'Envoyer dans Odoo',
                                        class: _normalizeClass({ 'form-disabled': !_ctx.vehicleSelected || _ctx.isProcessed }),
                                        onApprove: _ctx.approve,
                                        onRefuse: _ctx.refuse
                                      }, null, 8, ["loading", "loadingError", "withErrors", "data", "success-btn-label", "class", "onApprove", "onRefuse"]),
                                      (_ctx.isOthers)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label font-weight-bold" }, "Autre", -1)),
                                            _createVNode(_component_v_text_field, {
                                              modelValue: _ctx.customReason,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customReason) = $event)),
                                              placeholder: "entrer la raison",
                                              variant: "outlined",
                                              density: "compact",
                                              "hide-details": "auto",
                                              rules: _ctx.rules.coupon.customReason,
                                              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleRefuse('other')))
                                            }, null, 8, ["modelValue", "rules"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    lg: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_coupon_status, {
                                        processed: _ctx.isProcessed,
                                        item: _ctx.item,
                                        importError: _ctx.item.importResult,
                                        validateCouponError: _ctx.resultValidateCoupon
                                      }, null, 8, ["processed", "item", "importError", "validateCouponError"]),
                                      (_ctx.approvalError)
                                        ? (_openBlock(), _createBlock(_component_v_alert, {
                                            key: 0,
                                            type: "error",
                                            density: "compact",
                                            class: "mt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.approvalError), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.cropping)
        ? (_openBlock(), _createBlock(_component_coupon_cropper, {
            key: 0,
            modelValue: _ctx.cropping,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cropping) = $event)),
            item: _ctx.item,
            onClose: _ctx.cropperClosed
          }, null, 8, ["modelValue", "item", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}